<script>
    /**
     * ModalLetterTips
     */

    export default {
        alias: 'playVideo',
        defaultOptions () {
            return {};
        },
        modalCreated (options) {
            for (let key in options) {
                this[key] = options[key];
            }
        },
        data () {
            return {};
        },
        name: 'modal-video-player',
        methods: {
            onDestroy () {
                this.close();
            }
        },
        computed: {
            compVideoSrc () {
                return `${window.location.href.includes('localhost') ? '' : '/overseer_frontend_mobile'}/teach.mp4`
            }
        },
        components: {},
        mounted () {

        }
    };
</script>

<template>
    <div class="normal-modal">
        <div class="normal-modal__video">
            <video controls="controls" :src="compVideoSrc"></video>
        </div>
        <div class="normal-modal-btns">
            <div class="button" @click="onDestroy">&#xe7c5;</div>
        </div>
    </div>
</template>

<style lang="less" scoped>
    .normal-modal {
        position: absolute;
        background-color: transparent;
        left: 0.4rem;
        right: 0.4rem;
        margin-left: 0 !important;
        max-width: 100%;
        width: auto;

        video {
            background-color: @otherBtnBorderNoteClr;
            width: 100%;
            height: auto;
        }

        &-btns {
            .px2rem(margin-top, 30);

            .button {
                font-family: cmsicon;
                .px2rem(font-size, 64);
                color: #fff;
            }
        }
    }
</style>
